"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import styles from "./page.module.css";
import { EmailPasswordAuth } from "./EmailPasswordAuth";
import { PasskeyAuth } from "./PasskeyAuth";

type AuthTab = "password" | "passkey";

export function AuthSection() {
    const t = useTranslations("home.auth");
    const [activeTab, setActiveTab] = useState<AuthTab>("password");
    const [isRegisterMode, setIsRegisterMode] = useState(true);

    return (
        <div className={styles.authSection}>
            <div className={styles.authContainer}>
                <h2 className={styles.authTitle}>{t("title")}</h2>

                <div className={styles.tabs}>
                    <button
                        type="button"
                        className={`${styles.tab} ${activeTab === "password" ? styles.tabActive : ""}`}
                        onClick={() => setActiveTab("password")}
                    >
                        {t("passwordTab")}
                    </button>
                    <button
                        type="button"
                        className={`${styles.tab} ${activeTab === "passkey" ? styles.tabActive : ""}`}
                        onClick={() => setActiveTab("passkey")}
                    >
                        {t("passkeyTab")}
                    </button>
                </div>

                <div className={styles.authContent}>
                    {activeTab === "password" ? (
                        <EmailPasswordAuth isRegisterMode={isRegisterMode} />
                    ) : (
                        <PasskeyAuth isRegisterMode={isRegisterMode} />
                    )}

                    <div className={styles.modeToggle}>
                        {isRegisterMode ? (
                            <>
                                {t("hasAccount")}{" "}
                                <button
                                    type="button"
                                    className={styles.modeToggleButton}
                                    onClick={() => setIsRegisterMode(false)}
                                >
                                    {t("switchToLogin")}
                                </button>
                            </>
                        ) : (
                            <>
                                {t("needAccount")}{" "}
                                <button
                                    type="button"
                                    className={styles.modeToggleButton}
                                    onClick={() => setIsRegisterMode(true)}
                                >
                                    {t("switchToRegister")}
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
